//@flow
import React from 'react';
import {Route, Switch} from "react-router";
import {useSelector} from "react-redux";
import {
	ROUTE_PAGE_LOGIN, ROUTE_PAGE_FAST_LOGIN, ROUTE_PAGE_PRIVACY_POLICY,
	ROUTE_PAGE_TERMS_CONDITIONS,
	ROUTE_PAGE_RESET_PASSWORD,
	ROUTE_PAGE_RESET_PASS,
	ROUTE_PAGE_SIGN_UP,
	ROUTE_PAGE_UNAUTHORIZED_CALCULATION, ROUTE_PAGE_WIZARD,
	ROUTE_PAGE_UNAUTHORIZED_LANDING,
} from "./routes";
import {ROUTE_LOAN_APPLICATION_FAST} from "../modules/loanApplication/routes/routes";

const ROUTES = [
	ROUTE_PAGE_RESET_PASSWORD,
	ROUTE_PAGE_RESET_PASS,
	ROUTE_PAGE_SIGN_UP,
	ROUTE_PAGE_UNAUTHORIZED_CALCULATION,
	ROUTE_PAGE_TERMS_CONDITIONS,
	ROUTE_PAGE_PRIVACY_POLICY,
	ROUTE_PAGE_WIZARD,
	ROUTE_PAGE_LOGIN,
	ROUTE_PAGE_FAST_LOGIN,
	ROUTE_PAGE_UNAUTHORIZED_LANDING,
]

const UnauthenticatedRouter = () => {
	const fastLoginOtpVerified = useSelector((state) => state.currentUser.get('fastLoginOtpVerified'));
	// ROUTE_LOAN_APPLICATION_FAST must come BEFORE the non-exact '/' landing route,
	// otherwise the Switch matches the landing page first
	const routes = fastLoginOtpVerified
		? [
			...ROUTES.slice(0, -1),
			ROUTE_LOAN_APPLICATION_FAST,
			...ROUTES.slice(-1),
		]
		: ROUTES;
	return (
		<Switch>
			{routes.map(route => {
				const {key, path, exact, component} = route;
				return (
					<Route
						key={key}
						path={path}
						exact={exact}
						component={component}
					/>
				);
			})}
		</Switch>
	);
};

export default UnauthenticatedRouter;